import api from '../../plugins/api';

const getCities = (params) => {
  return api.get('/api/resource/getCities', params);
};

export default getCities;
